import React from 'react';
import {Link} from 'react-router-dom';

import swansLanding from '../images/swans-landing.jpg';

import {LanguageContext} from '../LanguageContext';

import translation from '../translations.json';

const intervention = '/manager-intervention';
const SouthallSitesManager = () => (
  <LanguageContext.Consumer>
    {({lang, changeLanguage}) => {
      return (
        <div className="flex flex-col text-center">
          <div className="bg-blue py-4">
            <h4 className="text-white text-2xl">{translation.site[lang.selected].SITE}</h4>
          </div>
          <Link to={{pathname: '/submission/swansLanding/manager-intervention', query: {intervention}}}>
            <img className="w-2/3 p-4 m-4 border-2 border-blue rounded" src={swansLanding} alt="" />
          </Link>
        </div>
      );
    }}
  </LanguageContext.Consumer>
);

export default SouthallSitesManager;



// WEBPACK FOOTER //
// ./src/components/SouthallSitesManager.js